import { ChangeDetectionStrategy, Component, Inject, computed, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ApmTranslatePipe } from '@mitsubishi/core';
import { ProjectSelectionsFacade, Selection } from '@mitsubishi/project/data-access';
import { SelectionStatus } from '@mitsubishi/shared/data-access';
import { ButtonComponent, SectionTitleComponent } from '@mitsubishi/shared/ui';

@Component({
  selector: 'apm-quote-selection',
  templateUrl: './quote-selection.component.html',
  styleUrls: ['./quote-selection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, ApmTranslatePipe, SectionTitleComponent],
})
export class QuoteSelectionComponent {
  selectedSelection = signal<Selection | undefined>(undefined);

  projectSelections = computed(() => {
    return this.projectSelectionsFacade
      .selectionsSignal()
      .filter(selection => selection?.details?.status === SelectionStatus.QUOTE_DRAFT);
  });

  constructor(
    private projectSelectionsFacade: ProjectSelectionsFacade,
    private dialogRef: MatDialogRef<QuoteSelectionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { unitId: string }
  ) {}

  quoteSelected(selection: Selection) {
    this.selectedSelection.set(selection);
  }

  save() {
    this.dialogRef.close(this.selectedSelection());
  }
}
